import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import Image from 'next/image';
import { SectionHeadline } from '@/components/SectionHeadline';
import { LINKS } from '@/constants/links';
import { Link } from '@/components/links';
export function AboutSkipPAy() {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["mallpay"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("aboutSkipPay.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Image src="/images/sections/mallpay/cs/app.png" alt={t1} width={600} height={603} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("aboutSkipPay.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <SectionHeadline className="m-0 text-center lg:text-left" anchorKey="aboutSkipPay.title">{t3}</SectionHeadline>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("aboutSkipPay.text.1");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="mx-auto max-w-[30rem] text-center text-sm lg:mx-0 lg:text-left lg:text-base">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link to={LINKS().whereToShop} analyticsParam="mallpayWhereToShop" testId="mallpayWhereToShop" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Link to={LINKS().card} analyticsParam="mallpayCard" testId="mallpayCard" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = <p className="mx-auto max-w-[30rem] text-center text-sm lg:mx-0 lg:text-left lg:text-base"><Trans t={t} i18nKey="aboutSkipPay.text.2">{t7}{t8}</Trans></p>;
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t9) {
    t10 = <div className="flex flex-col gap-4">{t4}{t6}{t9}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2) {
    t11 = <div className="grid max-w-7xl items-center gap-0 px-4 lg:mx-auto lg:grid-cols-2 lg:gap-24">{t2}{t10}</div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}